import { handleFeaturedRatesUpdate } from '../components/handle-rates-update'
import { MarketBrief } from 'models/market'
import { handleFeaturedTimer } from 'utils/handle-featured-timer'

declare const USER_BASE_URL_WT: string
declare const CMS_BASE_URL_WT: string

/**
 * Inform web worker to init fetching marketBrief in intervals.
 *
 * @param {*} worker
 */
const initMarketBriefInterval = (worker: Worker): void => {
  worker.postMessage(['initMarketBrief', { interval: 10 * 1000, baseUrl: USER_BASE_URL_WT }])
  worker.postMessage(['initTickTock'])
}

const workerHandler = (actionType: string, payload: any): void => {
  const workerJobs = {
    tickTock: (): void => {
      handleFeaturedTimer()
    },
    marketBriefUpdate: (payload: MarketBrief[]): void => {
      handleFeaturedRatesUpdate(payload)
    },
    missingAction: (): void => {
      console.error('[Worker Handler] Idle worker run')
    },
  }
  workerJobs[actionType] ? workerJobs[actionType](payload) : workerJobs['missingAction']()
}

export function initWebWorker(): void {
  if (window.Worker) {
    const wtWorker = new Worker(
      // TODO: Fix issue with this long absolute URL.
      new URL(`${CMS_BASE_URL_WT}/wp-content/themes/wt-theme/assets/scripts/global/webWorker.js`),
    )

    /* PUT HERE ALL WORKER JOBS */
    initMarketBriefInterval(wtWorker)

    /* PUT HERE ALL WORKER MESSAGE HANDLERS */
    wtWorker.onmessage = (event: MessageEvent): void => {
      const action = event.data.action || 'missingAction'
      const payload = event.data.payload || []
      workerHandler(action, payload)
    }
  } else {
    // TODO: Should we fallback if no webworker available?
    console.error('[Compatibility] WebWorkers not supported.')
  }
}
